const rvsCertificateDates = {
  MIN_VALID_CERTIFICATE_DATE: '2023-07-01',
  TESTING_TEST_CENTRE_FIELD_DATE: '2024-12-05', // -- pick the date of the certificate (#483896) we can test with
  PROD_TEST_CENTRE_FIELD_DATE: '2025-01-09'
};

module.exports = {
  rvsCertificateDates
};
